import {Location} from "@angular/common";
import {inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  private location = inject(Location);
  private router = inject(Router);

  constructor() {}

  open(url: string): void {
    this.router.navigate([url]);
  }

  back(): void {
    this.location.back();
  }
}
